import React from "react";
import { useSelector } from "react-redux";
import { constants } from "@qgiv/core-js";
import { selectAllRegistration } from "../../../../../../redux/slices/registrationSlice";
import { selectAllP2pSettings } from "../../../../../../redux/slices/p2pSettingsSlice";
import { selectAllClassifications } from "../../../../../../redux/slices/classificationsSlice";
import { selectAllCategories } from "../../../../../../redux/slices/categoriesSlice";
import { selectCmsControlByType } from "../../../../../../redux/slices/cmsSettingsSlice";
import NoResults from "./NoResults";

const ConnectedNoResults = () => {
    const {
        ENUMS: {
            CMS_Control: { P2P_REGISTRATION_CONTENT },
        },
    } = constants;

    const registration = useSelector(selectAllRegistration);
    const {
        classification: { Classification },
        currentRegistration,
        currentRegistrationCategory,
    } = registration;
    const p2pSettings = useSelector(selectAllP2pSettings);
    const { enableTeamCreation } = p2pSettings;

    const classifications = useSelector(selectAllClassifications);
    const categories = useSelector(selectAllCategories);

    const currentCategory = categories.find(
        (cat) => cat.id === Number(currentRegistrationCategory),
    );

    const classification =
        Object.keys(registration.classification).length > 0 &&
        typeof Classification[0] === "string"
            ? classifications.find(({ id }) => `${id}` === Classification[0])
            : {};

    const { displayTeamSpotsLeft = false, teamSpotsLeft } = classification;

    const teamLimitReached =
        displayTeamSpotsLeft &&
        typeof teamSpotsLeft === "number" &&
        teamSpotsLeft === 0;

    const displayCreateNewTeam =
        enableTeamCreation &&
        !teamLimitReached &&
        currentRegistration === 0 &&
        !!currentCategory?.attachTeamCaptains;

    const control = useSelector((state) =>
        selectCmsControlByType(P2P_REGISTRATION_CONTENT, state),
    );
    const {
        options: {
            joinTeamModal: {
                createTeamButtonLabel = "Start A New Team",
                noSearchResultsLabel = "🤔 We can't find a team or team captain that matches your search.",
                noTeamsLabel = "There aren't any teams yet. Go on—be the first!",
            },
        },
    } = control;

    const noResultsProps = {
        createTeamButtonLabel,
        displayCreateNewTeam,
        noSearchResultsLabel,
        noTeamsLabel,
    };
    return <NoResults {...noResultsProps} />;
};

export default ConnectedNoResults;
